'use client';

import type React from 'react';

interface LoadingSpinnerProps {
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message }) => {
  return (
    <div className='flex flex-col justify-center items-center py-10 space-y-4'>
      <div className='w-12 h-12 border-4 border-t-4 border-primary rounded-full animate-spin'></div>
      {message ? <span className='text-primary text-lg'>{message}</span> : <span className='sr-only'>Loading...</span>}
    </div>
  );
};

export default LoadingSpinner;
